import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export const ProtectedRoute = ({ children, requirePerm }) => {
  const { user, perms } = useAuth();
  if (user === undefined) {
    return (
      <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center" style={{ background: "#0F1D14", color: "#D4AF37" }}>
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requirePerm && !perms[requirePerm]) {
    return (
      <div data-testid="forbidden" className="min-h-screen flex items-center justify-center text-center px-6" style={{ background: "#0F1D14", color: "#F5EFE0" }}>
        <div>
          <h1 className="font-serif-bv text-4xl text-[#D4AF37] mb-2">Access Denied</h1>
          <p className="text-[#F5EFE0]/70">You do not have permission to view this page.</p>
          <p className="text-xs mt-3 tracking-widest uppercase text-[#D4AF37]/60">Required: {requirePerm}</p>
        </div>
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
